module.exports = __webpack_public_path__ + "static/media/hb-prime-banner-icon.f41fc21f.png";